module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c14-70b859ea5caeb5f3262f29e11c1f31ac.jpg";